<app-dialog-header [title]="data.title" (closeDialog)="closeDialog()"></app-dialog-header>
<mat-dialog-content>
  @if (data.content) {
    @for (content of data.content; track content) {
      <div
        class="content-body"
        [class.scoped]="content.scope"
        [class.warning]="content.scope === 'warning'"
        [class.danger]="content.scope === 'danger'"
      >
        @if (content.scope) {
          <div class="scope-header">
            <lucide-icon [img]="icons.get(content.scope)" [size]="20" class="mr-1"></lucide-icon>
            <span class="text-lg">{{ content.title }}</span>
          </div>
        }
        <div [class.scope-content]="content.scope" [innerHTML]="content.message"></div>
      </div>
    }
    @if (data.textInput) {
      <input
        placeholder="{{ data.textInputPlaceholder }}"
        [(ngModel)]="inputValue"
        class="dialog-input"
      />
    }
    @if (data.checkBox) {
      @if (data.checkBox) {
        <mat-checkbox
          class="checkbox"
          [ngModel]="checked"
          (ngModelChange)="checked = $event"
        ></mat-checkbox>
      }
      {{ data.checkBox }}
    }
    @if (data.radioOptions && data.radioOptions.length) {
      <div class="radio-group">
        @for (option of data.radioOptions; track option; let i = $index) {
          <mat-radio-group
            class="radio-group"
            [ngModel]="selectedOption"
            (ngModelChange)="selectedOption = $event"
          >
            <mat-radio-button class="radio-button" [value]="i + 1">
              {{ option }}
            </mat-radio-button>
          </mat-radio-group>
        }
      </div>
    }
  }
  <ng-content></ng-content>
</mat-dialog-content>
@if (data.buttons?.length) {
  <div class="dialog-actions">
    @for (button of data.buttons; track button.text) {
      <app-new-action-button
        [isDisabled]="
          button.theme === 'danger-secondary' &&
          data.radioOptions &&
          data.radioOptions.length &&
          !selectedOption
        "
        [testId]="button.testId"
        [text]="button.text"
        (actionCompleted)="action(button.action)"
        [themedButton]="button.theme"
        [icon]="button.icon"
      ></app-new-action-button>
    }
  </div>
}
